import type { BadgePreview, OpenBadge } from '@/types'
import { apiClient } from './client'

type CreateBadgePayload =
  | { badge_url: string; badge_name?: string; achievement?: number | null }
  | { json_data: Record<string, unknown>; badge_name?: string; achievement?: number | null }

export const getBadges = () =>
  apiClient.get<OpenBadge[]>('/badges/').then((r) => r.data)

export const createBadge = (data: CreateBadgePayload) =>
  apiClient.post<OpenBadge>('/badges/', data).then((r) => r.data)

export const updateBadge = (id: number, data: Partial<OpenBadge>) =>
  apiClient.patch<OpenBadge>(`/badges/${id}/`, data).then((r) => r.data)

export const deleteBadge = (id: number) =>
  apiClient.delete(`/badges/${id}/`)

export const previewBadge = (data: { badge_url?: string; json_data?: Record<string, unknown> }) =>
  apiClient.post<BadgePreview>('/badges/preview/', data).then((r) => r.data)
